module.exports = __webpack_public_path__ + "img/Lets-play-to-01@2x.6695c42a.jpg";